

























import { defineComponent, ref } from '@vue/composition-api'
import { mdiAccountOutline, mdiLockOpenOutline } from '@mdi/js'

// Components
import AccountSettingsAccount from '../../components/AccountSettingsAccount.vue'
import AccountSettingsSecurity from '../../components/AccountSettingsSecurity.vue'

export default defineComponent({
  components: {
    AccountSettingsAccount,
    AccountSettingsSecurity,
  },
  setup() {
    const tab = ref('')

    // tabs
    const tabs = [
      { title: 'Información Personal', icon: mdiAccountOutline },
      { title: 'Cambiar Contraseña', icon: mdiLockOpenOutline },
    ]

    return {
      tab,
      tabs,
    }
  },
})
